<template>
  <div>
    <ImportData :isFlag="importdata" @refreshData="getData"></ImportData>
    <el-dialog
      :title="getTitle"
      :visible.sync="dialog"
      width="600px"
      style="text-align: left"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      append-to-body
      class="big cus-doctorConfig-banner"
    >
      <div class="add-box">
        <el-form
          :model="bannerDiaForm"
          :rules="rules"
          ref="bannerDiaFormRef"
          label-width="140px"
          class="info-form"
        >
          <el-form-item
            v-if="type == 3"
            :label="`${getTitle}名称`"
            prop="title"
          >
            <el-input
              v-model="bannerDiaForm.title"
              style="width: 400px"
              :disabled="isDisable"
              maxlength="20"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item v-else :label="`${getTitle}说明`" prop="desc">
            <el-input
              v-model="bannerDiaForm.desc"
              style="width: 400px"
              :disabled="isDisable"
              clearable
            ></el-input>
          </el-form-item>

          <template v-if="type == 2">
            <el-form-item label="Banner位置" prop="position" class="info-type">
              <el-select
                v-model="bannerDiaForm.position"
                clearable
                placeholder="请选择"
                @change="changePosition"
              >
                <el-option
                  v-for="item in positionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </template>

          <el-form-item
            :label="`${getTitle}主图`"
            prop="image"
            :class="type == 2 ? 'banner-box' : 'image-box'"
          >
            <el-upload
              list-type="picture-card"
              :disabled="isDisable"
              :action="uploadUrl"
              :show-file-list="false"
              name="image"
              accept=".png,.jpeg,.jpg"
              ref="iconImgRef"
              class="box"
              :headers="uploadHeaders"
              :data="uploadExtraData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeUpload"
            >
              <img
                v-if="bannerDiaForm.image_str"
                :src="bannerDiaForm.image_str"
                style="width: 148px; height: 148px"
              />
              <div v-else class="icon-box">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div
                v-show="bannerDiaForm.image_str"
                class="shadow column-center column"
              >
                <div>
                  <i class="el-icon-delete" @click.stop="delImg()"></i>
                </div>
              </div>
            </el-upload>
            <span v-if="type == 2">{{ bannerSize }}</span>
          </el-form-item>

          <template v-if="type == 3">
            <el-form-item
              :label="`${getTitle}时间`"
              prop="date"
              class="bannerDiaForm-date"
            >
              <el-date-picker
                v-model="bannerDiaForm.start_time"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :disabled="isDisable"
                placeholder="开始日期"
                size="samll"
              >
              </el-date-picker>
              <span>&nbsp;至&nbsp;</span>
              <el-date-picker
                v-model="bannerDiaForm.end_time"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :disabled="isDisable"
                placeholder="结束日期"
                size="samll"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item :label="`${getTitle}描述`" class="ac-desc">
              <el-input
                v-model="bannerDiaForm.desc"
                type="textarea"
                maxlength="50"
                :disabled="isDisable"
              ></el-input>
            </el-form-item>
          </template>

          <el-form-item :label="`${getTitle}链接`" prop="banner_url">
            <el-input
              v-model="bannerDiaForm.banner_url"
              style="width: 400px"
              :disabled="isDisable"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="操作类型" prop="min_type" class="info-type">
            <el-select
              v-model="bannerDiaForm.min_type"
              clearable
              :disabled="isDisable"
              @change="changeMinType(bannerDiaForm.min_type)"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" prop="is_share" style="margin-top: -10px">
            <el-checkbox
              v-model="bannerDiaForm.is_share"
              :true-label="1"
              :false-label="0"
              :disabled="isDisable"
              >允许分享到微信</el-checkbox
            >
          </el-form-item>

          <el-form-item
            v-if="type != 3"
            label="是否医生助理可见"
            prop="ass_auth"
            style="margin-top: -20px"
            class="ass-auth"
          >
            <el-radio-group v-model="bannerDiaForm.ass_auth">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="可见性"
            prop="doctor_auth"
            style="margin-top: -20px"
          >
            <el-radio-group
              v-model="bannerDiaForm.doctor_auth"
              :disabled="isDisable"
            >
              <el-radio :label="1">全部医生</el-radio>
              <el-radio :label="2">部分医生</el-radio>
            </el-radio-group>
            <el-button
              v-if="bannerDiaForm.doctor_auth === 2 && !isDisable"
              type="primary"
              size="mini"
              style="margin-left: 10px"
              @click="addData"
              >导入手机号</el-button
            >
            <el-button
              v-if="isDisable"
              type="primary"
              size="mini"
              style="margin-left: 10px"
              @click="addData"
              >添加医生手机号</el-button
            >
          </el-form-item>

          <el-form-item
            v-if="bannerDiaForm.doctor_auth === 2"
            style="padding-right: 20px; margin-top: -20px; margin-bottom: 120px"
          >
            <div style="margin: -15px 0 -6px 0">
              已选择{{ doctor_length }}位医生参与
            </div>

            <el-input
              type="textarea"
              :disabled="isDisable"
              v-model="bannerDiaForm.doctor_string"
              :rows="6"
              placeholder="请填写指定医生手机号，多个用英文逗号隔开"
              onkeyup="this.value=this.value.replace(/[ ]/g,'')"
            >
            </el-input>
          </el-form-item>

          <el-form-item class="btn-box">
            <el-button type="primary" @click="submitForm('bannerDiaFormRef')"
              >保 存</el-button
            >
            <el-button @click="resetForm">取 消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import marketing from "../../../../api/marketing";
import constant from "@/service/common/constant";
import ImportData from "./ImportData.vue";
import dayjs from "dayjs";
export default {
  props: {
    dialog: {
      type: Boolean,
      require: true,
      default: false,
    },
    isDisable: {
      type: Boolean,
      require: true,
      default: false,
    },
    id: {
      type: [String, Number],
      require: true,
    },
    type: {
      type: [String, Number],
      require: true,
    },
    axiosUrl: {
      type: String,
      require: true,
      default: "saveDoctorBanner",
    },
    axiosInfoUrl: {
      type: String,
      require: true,
      default: "getDoctorBannerInfo",
    },
  },
  components: {
    ImportData,
  },
  data() {
    return {
      title: "Banner",
      bannerDiaForm: {
        title: "",
        desc: "",
        banner_url: "",
        image: "",
        image_str: "",
        min_type: "",
        is_share: 0,
        ass_auth: "",
        doctor_auth: 1,
        doctor_string: "",
        position: 1,
        start_time: "",
        end_time: "",
      },
      importdata: false,
      uploadExtraData: {
        img_type: 4,
        suffix: ".jpg",
      },
      rules: {
        desc: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            min: 1,
            max: 300,
            message: "长度在 1 到 300 个字符",
            trigger: "blur",
          },
        ],
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        banner_url: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
        position: [{ required: true, message: "请选择", trigger: "change" }],
        min_type: [{ required: true, message: "请选择", trigger: "change" }],
        image: [{ required: true, message: "请上传图片", trigger: "blur" }],
        ass_auth: [{ required: true, message: "请选择", trigger: "change" }],
      },
      dialogIcon: false,
      options: [
        {
          label: "原生路由",
          value: 1,
        },
        {
          label: "跳转链接",
          value: 2,
        },
        {
          label: "无操作",
          value: 0,
        },
      ],
      positionOptions: [
        {
          label: "下方",
          value: 1,
        },
        {
          label: "左侧",
          value: 2,
        },
        {
          label: "右侧",
          value: 3,
        },
      ],
      bannerSize: "建议684*174px",
    };
  },
  computed: {
    getTitle() {
      switch (this.type) {
        case 1:
          return "弹窗";
        case 2:
          return "Banner";
        case 3:
          return "活动";
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    doctor_length() {
      if (this.bannerDiaForm.doctor_string) {
        let arr = this.bannerDiaForm.doctor_string.split(",");
        return arr.length;
      } else {
        return 0;
      }
    },
    uploadUrl() {
      if (process.env.NODE_ENV == "development") {
        // 本地开发使用 api 前缀
        return "/api/platform/upload/uploadFile";
      } else {
        return "/platform/upload/uploadFile";
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ["version", "platform", "appid"]),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken,
        }
      );
    },
  },
  watch: {
    id: {
      handler: function (n, o) {
        if (n != -1) {
          this.getInfo(n);
        } else {
          this.bannerDiaForm = {
            title: "",
            desc: "",
            banner_url: "",
            image: "",
            image_str: "",
            min_type: "",
            is_share: 0,
            ass_auth: "",
            doctor_auth: 1,
            doctor_string: "",
            position: 1,
            start_time: "",
            end_time: "",
          };
          this.$refs["bannerDiaFormRef"].resetFields();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 获取医生端活动配置详情
    getInfo(id) {
      marketing[this.axiosInfoUrl]({ banner_id: id }).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.bannerDiaForm = Object.assign(this.bannerDiaForm, data.info);
          if (this.type == 3) {
            let start_time = dayjs
              .unix(data.info.start_time)
              .format("YYYY-MM-DD");
            let end_time = dayjs.unix(data.info.end_time).format("YYYY-MM-DD");
            this.bannerDiaForm.start_time = start_time;
            this.bannerDiaForm.end_time = end_time;
          }
          this.changePosition(data.info.position);
        }
      });
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList) {
      let { code, data } = res;
      if (code === 0) {
        this.bannerDiaForm.image_str = data.path;
        this.bannerDiaForm.image = data.pic;
        this.$message.success("上传图片成功");
      }
    },
    // 上传之前
    beforeUpload(file) {
      const supportImgTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error("上传图片只能是 jpg, png, jpeg 格式!");
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf("."));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
    },
    //导入数据
    addData() {
      this.importdata = !this.importdata;
    },
    changeMinType(minType) {
      if (!minType) {
        this.rules.banner_url[0].required = false;
      } else {
        this.rules.banner_url[0].required = true;
      }
    },
    delImg() {
      if (this.isDisable) {
        return;
      }
      this.bannerDiaForm.image_str = "";
      this.bannerDiaForm.image = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.bannerDiaForm.doctor_auth == 2) {
            if (!this.bannerDiaForm.doctor_string) {
              this.$message.error("请填写或导入医生手机号");
              return false;
            }
          }
          let isAdd = this.id == -1 ? true : false;
          let params = isAdd
            ? this.bannerDiaForm
            : Object.assign({ banner_id: this.banner_id }, this.bannerDiaForm);
          params["type"] = this.type;

          marketing[this.axiosUrl](params).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success(`${isAdd ? "添加" : "编辑"}成功`);
              this.$emit("close", 1);
            }
          });
        } else {
          return false;
        }
      });
    },
    getData(code_array) {
      if (this.bannerDiaForm.doctor_string) {
        let string = this.bannerDiaForm.doctor_string.split(",");
        let arr = string.concat(code_array);
        this.bannerDiaForm.doctor_string = arr.toString();
      } else {
        this.bannerDiaForm.doctor_string = code_array.toString();
      }
    },
    resetForm() {
      this.$emit("close");
    },
    beforeClose() {
      this.$emit("close");
    },
    // banner位置改变
    changePosition(position) {
      switch (position) {
        case 1:
          this.bannerSize = "建议684*174px";
          break;
        case 2:
          this.bannerSize = "建议372*202px";
          break;
        case 3:
          this.bannerSize = "建议290*202px";
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-box {
  padding: 20px 10px 1px;
  display: flex;
  .icon-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 148px;
    height: 148px;
  }
  .box {
    position: relative;
    width: 148px;
    &:hover .shadow {
      display: flex;
    }
    img {
      width: 148px;
      height: 148px;
    }
    .shadow {
      position: absolute;
      left: 0;
      top: 0;
      width: 148px;
      height: 148px;
      background-color: rgba(0, 0, 0, 0.6);
      display: none;
    }
    .el-icon-delete {
      font-size: 30px;
      text-align: center;
      cursor: pointer;
      color: #d44747;
    }
  }
  .btn-box {
    text-align: right;
    padding-right: 20px;
  }
}
.ass-auth {
  ::v-deep .el-form-item__content {
    height: 30px !important;
  }
}
.image-box {
  ::v-deep .el-form-item__content {
    height: 160px !important;
  }
}
.banner-box {
  ::v-deep .el-form-item__content {
    height: 180px !important;
  }
}
.ac-desc {
  ::v-deep .el-form-item__content {
    height: auto;
  }
}
.bannerDiaForm-date {
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    .el-date-editor {
      width: 200px;
    }
  }
}
</style>
<style lang="scss"></style>
